package ui.styles

import emotion.css.ClassName
import ui.pages.Area
import ui.pages.Sizes
import web.cssom.*

object DrawerStyle {
    val drawerHandler = ClassName(ClassName("drawer_handler")) {
        display = Display.flex
        flexDirection = FlexDirection.column
        justifyContent = JustifyContent.spaceBetween
    }

    val drawerOpenToken = "drawer_open"

    val drawerTitleBox = ClassName(ClassName("drawer_title_box")) {
        gridArea = Area.DrawerBox.drawerTitle
    }

    val drawerTopBox = ClassName(ClassName("drawer_top_box")) {
        gridArea = Area.DrawerBox.drawerTop
        display = Display.grid
        gap = 4.px
    }

    val drawerBottomBox = ClassName(ClassName("drawer_bottom_box")) {
        gridArea = Area.DrawerBox.drawerBottom
        marginBottom = 10.px
    }
}